/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Menu/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Collapsed from './Collapsed/index'
import Expanded from './Expanded/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Menu({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Menu"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let globalSidebarTogglesIsTasksSidebarOpenValueData = fromData.useDataFormat({ viewPath,
context: 'global',
path: 'sidebar_toggles.is_tasks_sidebar_open',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: globalSidebarTogglesIsTasksSidebarOpenValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Expanded'}>
<Expanded
  viewPath={`${viewPath}/Expanded`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Collapsed'}>
<Collapsed
  viewPath={`${viewPath}/Collapsed`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}